export const API = {
  DATA_ENDPOINT: 'https://api-edge.askmiso.com/v1',
  EVENT_ENDPOINT: 'https://api.askmiso.com/v1'
};